import { TextCodes } from '@api/types/translation/TextCodes';
import { CommonModal, ProductDetailsContext } from '@components';
import { FormContainerBlock } from '@components/blocks/forms/FormContainerBlock';
import { Box, Button } from '@mui/material';
import { t } from '@translations';
import { useContext, useState } from 'react';

export const ProductOrderForm = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const formModel = product.productOrderForm?.expanded?.formModel;
  if (!formModel?.assets || !formModel?.template) {
    return null;
  }
  return (
    <>
      <Button
        variant='text'
        sx={{ background: '#fff', color: '#000', height: '44px' }}
        onClick={() => setIsModalOpen(!isModalOpen)}
      >
        {t(TextCodes.Product.Details.OrderProduct)}
      </Button>
      <CommonModal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box className='request-modal'>
          <FormContainerBlock
            formModel={product.productOrderForm?.expanded?.formModel}
            contentLink={product.contentLink}
          />
        </Box>
      </CommonModal>
    </>
  );
};
